import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.6.4@antd/es/form/index.js
// module id = 640
// module chunks = 0